import _ from 'lodash'

/** Locale → key → translated string. This is the shape `translateString` consumes. */
export type UI2TranslationTable = Record<string, Record<string, string>>

/**
 * Renderer-injected props shared by every ui2 field/display component; never uiSchema-set.
 */
export interface UI2BaseFieldInternalProps {
  /** Supplies the ambient translation table, bound data schema, and focus-target value path. */
  frames?: any
  /** The entity the current context is bound to. */
  entity?: any
  /** Merged over frames.getContext('translationTable') — local entries win. */
  translationTable?: any
  testID?: string
}

/**
 * Merge a local translation table over the frames one (local wins). Deep, not shallow: the table
 * is locale → key → string, so a shallow merge would replace a locale's whole block, not add to it.
 */
export function getEffectiveTranslationTable(
  props: Pick<UI2BaseFieldInternalProps, 'translationTable' | 'frames'>,
): UI2TranslationTable {
  return _.merge({}, props.frames?.getContext?.('translationTable'), props.translationTable)
}
